import { render } from "./TabsViewTab.vue?vue&type=template&id=5d4e86fc&scoped=true"
import script from "./TabsViewTab.vue?vue&type=script&lang=js"
export * from "./TabsViewTab.vue?vue&type=script&lang=js"

import "./TabsViewTab.vue?vue&type=style&index=0&id=5d4e86fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4e86fc"]])

export default __exports__